import { alpha, Card, styled } from '@/shared/ui/mui';
/**
 * HoverCard - A card with lift animation and shadow effect on hover
 *
 * Features:
 * - Smooth transition on hover
 * - Translates up (lift effect)
 * - Enhanced shadow with purple tint
 * - Rounded corners
 * - Perfect for team cards, reviews, shop cards, etc.
 *
 * Usage:
 * ```tsx
 * <HoverCard>
 *   <CardContent>
 *     {/* Your content *\/}
 *   </CardContent>
 * </HoverCard>
 * ```
 */
export const HoverCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-8px)',
    boxShadow: `0 12px 20px ${alpha(theme.palette.primary.main, 0.15)}`,
  },
}));
